

export default (state = [], action) => {
    if (action.type === 'FETCH_SIDE_LIST') {
        return action.payload
    }

    return state;
}